import { Box, Button, Card, Divider, TextField, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useSnackbar } from 'notistack'
import { FC, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import GCLogoSrc from "../assets/GCLogo.png"
import GSLogoSrc from "../assets/GSLogo.png"
import { Center, EnqueueSnackbarType, showMessage } from '../components/common/Helpers'
import { CompanyType, resetPassword } from '../redux/appReducer'
import { StateType } from '../redux/store'

const defaultLogoSrc = window.location.hostname.includes('thegarageshop') ? GSLogoSrc : GCLogoSrc

interface IProps {
    company: undefined | CompanyType

    resetPassword(code: string, password: string, enqueueSnackbar: EnqueueSnackbarType): void
}

const useStyles = makeStyles(theme => ({
    form: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    input: {
        marginBottom: '1rem',
        fontSize: '0.8rem'
    },
    logo: {
        width: '50%',
        marginBottom: '1rem',
        marginTop: "4rem"
    },
    card: {
        minWidth: 320,
        padding: '2rem 3rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // [theme.breakpoints.down('xs')]: {
        //     display: "none"
        // }
    }
}))

const Forgot: FC<IProps> = props => {
    const styles = useStyles()

    const params = useParams<{ code: string | undefined }>()

    const [code, setCode] = useState('')
    const [password, setPassword] = useState('')
    const [repeatPassword, setRepeatPassword] = useState('')

    const { enqueueSnackbar } = useSnackbar()

    useEffect(() => {
        if (params.code) {
            setCode(params.code)
        }
    }, [])

    const handleSubmit = () => {
        if (!code) {
            showMessage(enqueueSnackbar, 'Recovery Code is required')
            return
        }
        if (!password) {
            showMessage(enqueueSnackbar, 'New Password is required')
            return
        }
        if (password !== repeatPassword) {
            showMessage(enqueueSnackbar, 'Passwords not matches')
            return
        }

        props.resetPassword(code, password, enqueueSnackbar)
    }

    return (
        <Center>
            <img className={styles.logo}
                src={props.company ? props.company.logoURL : defaultLogoSrc} alt='Logo' />
            <Card className={styles.card}>
                <Typography style={{ fontWeight: 'bolder' }}>Reset Password</Typography>
                <Box className={styles.form}>
                    <TextField
                        label="Recovery Code"
                        variant="outlined"
                        value={code}
                        onChange={e => { setCode(e.target.value) }}
                        style={{ width: '100%', marginTop: 15 }}
                        onKeyDown={e => { if (e.key === 'Enter') handleSubmit() }}
                    />
                    <TextField
                        label="New Password"
                        variant="outlined"
                        type='password'
                        value={password}
                        onChange={e => { setPassword(e.target.value) }}
                        style={{ width: '100%', marginTop: 15 }}
                        onKeyDown={e => { if (e.key === 'Enter') handleSubmit() }}
                    />
                    <TextField
                        label="Repeat New Password"
                        variant="outlined"
                        type='password'
                        value={repeatPassword}
                        onChange={e => { setRepeatPassword(e.target.value) }}
                        style={{ width: '100%', marginTop: 15 }}
                        onKeyDown={e => { if (e.key === 'Enter') handleSubmit() }}
                    />
                    <Button style={{ marginTop: 15 }} size="medium" color='primary' variant="contained" onClick={handleSubmit}>Confirm</Button>
                </Box>
                <Divider />
                <hr style={{ margin: '15px', height: '1px', border: 0, borderTop: '1px solid hsl(0,0%,80%)', width: '100%' }} />
                <Link style={{ color: "#0052CC", fontSize: "14px" }} to="/login" >Log In</Link>
            </Card>
        </Center>
    )
}

const mapStateToProps = (state: StateType) => ({
    company: state.appReducer.company,
})

export default connect(mapStateToProps, {
    resetPassword
})(Forgot)